module.exports = __webpack_public_path__ + "img/report.3fcc79b5.svg";